import { css } from "@vitality-ds/system";
export default css({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
});